import Model from './Model'

class User extends Model {
  static primaryKey = 'id'
  static entity = 'user'

  static fields () {
    return {
      id: this.attr(null),
      login: this.attr(null),
      email: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      phone: this.attr(null),
      usertype: this.attr(null),
      membershipid: this.attr(null),
      fb_id: this.attr(null),
      fb_data: this.attr(null),
      rewards: this.attr(null),
      drip_optin: this.attr(null)
    }
  }
}

export default User
